import clsx from 'clsx';
import React from 'react';
import { ButtonGroup } from '../ButtonGroup';
import { Image } from '../Image';
import { SpotlightProps } from './Spotlight.types';

export const Spotlight = ({
  categoryText,
  mainHeadingText,
  leadText,
  image,
  children,
  buttons,
  reverse,
  alignTop,
  paddingStyle = 'IconList',
}: SpotlightProps): JSX.Element => {
  return (
    <div
      className={clsx('spotlight', {
        spotlight_reverse: reverse,
        'spotlight_text-list': paddingStyle === 'TextList',
        'spotlight_align-top': alignTop,
      })}
    >
      {image && (
        <div className='spotlight__image-wrapper'>
          <Image {...image} figureClassNames='spotlight__media' />
        </div>
      )}
      <div className='spotlight__content'>
        {/* Category Text */}
        {categoryText && <div className='text-heading_5'>{categoryText}</div>}

        {/* Main Heading Text */}
        {mainHeadingText && (
          <div className={clsx('spotlight__section-title', 'text-heading_2')}>
            {mainHeadingText}
          </div>
        )}

        {/* Lead Text */}
        {leadText && <div className='text-lead_2'>{leadText}</div>}

        {/* Content */}
        {children}

        {buttons && <ButtonGroup buttons={buttons} />}
      </div>
    </div>
  );
};
